import { DashboardInsight } from "@/components/dashboard-insight/DashboardInsight";

const DashboardInsightPage = () => <DashboardInsight />;

export default DashboardInsightPage;
